module.exports = __webpack_public_path__ + "img/plano_saude.95dc130f.svg";